module.exports = __webpack_public_path__ + "static/media/copyright.32f95caf.svg";